import { ReduxHelpers } from 'hb4e-ui-core'

import {
  SET_MY_LISTS_FETCHING,
  SET_MY_LISTS,
  SET_ACTIVE_LIST_FETCHING,
  SET_ACTIVE_LIST,
  SET_ADDITIONAL_LISTS,
  SET_LIST_SEARCH_RESULTS,
  RESET_LIST_SEARCH_RESULTS,
  TOGGLE_IS_REORDERING,
  SET_REORDERED_LIST_ITEMS,
  RESET_LIST_REORDERING,
} from './constants'

export const defaultState = {
  myLists: {
    isFetching: false,
    lists: [],
    totalLists: 0,
    nextOffset: 0,
    limit: 0,
  },
  activeList: {
    isFetching: false,
    list: null,
  },
  searchResults: {
    listResults: null,
    itemResults: null,
    isStale: true,
  },
  listReordering: {
    isReordering: false,
    reorderableItems: [],
  },
}

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_MY_LISTS:
      return {
        ...state,
        myLists: {
          isFetching: false,
          lists: action.lists,
          totalLists: action.totalLists,
          page: action.page,
          nextOffset: action.nextOffset,
          limit: action.limit,
        },
      }
    case SET_MY_LISTS_FETCHING:
      return {
        ...state,
        myLists: {
          ...state.myLists,
          isFetching: true,
        },
      }
    case SET_ACTIVE_LIST:
      return {
        ...state,
        activeList: {
          isFetching: false,
          list: action.list,
        },
      }
    case SET_ACTIVE_LIST_FETCHING:
      return {
        ...state,
        activeList: {
          ...state.activeList,
          isFetching: true,
        },
      }
    case SET_ADDITIONAL_LISTS:
      return {
        ...state,
        myLists: {
          ...state.myLists,
          // appends lists to state and deduplicates
          lists: [...state.myLists.lists, ...action.lists].filter(
            (list, index, arr) =>
              index === arr.findIndex((listToCompare) => list.getServerID() === listToCompare.getServerID()),
          ),
          nextOffset: action.nextOffset,
          limit: action.limit,
        },
      }
    case RESET_LIST_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          isStale: true,
        },
      }
    case SET_LIST_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: {
          ...action.searchResults,
          isStale: false,
        },
      }
    case TOGGLE_IS_REORDERING:
      return {
        ...state,
        listReordering: {
          ...state.listReordering,
          isReordering: !state.listReordering.isReordering,
        },
      }
    case SET_REORDERED_LIST_ITEMS:
      return {
        ...state,
        listReordering: {
          ...state.listReordering,
          reorderableItems: action.data,
        },
      }
    case RESET_LIST_REORDERING:
      return {
        ...state,
        listReordering: {
          ...defaultState.listReordering,
        },
      }
    default:
      return state
  }
}

export default reducer

export const stateKey = 'lists'
const createSelector = ReduxHelpers.asyncRegisterReducer(stateKey, reducer)

export const selectMyLists = createSelector((state) => state.myLists)

export const selectActiveList = createSelector((state) => state.activeList)

export const selectPersonalLists = createSelector(
  (state) => state.myLists.lists?.filter((list) => list.isPersonalList()) || [],
)

export const selectList = createSelector((state, listID) =>
  state.myLists.lists?.find((list) => list.getID() === listID),
)

export const selectSavedItemLists = createSelector(
  (state) => state.myLists.lists?.filter((list) => list.isSavedItemsList()) || [],
)

export const selectPurchasedItemLists = createSelector(
  (state) => state.myLists.lists?.filter((list) => list.isPurchasedList()) || [],
)

export const selectTrialLists = createSelector(
  (state) => state.myLists.lists?.filter((list) => list.isFreeTrialsList()) || [],
)

export const selectLists = createSelector((state) => {
  return state.myLists.lists
})

export const selectListSearchResults = createSelector((state) => state.searchResults)

export const selectIsReordering = createSelector((state) => state.listReordering.isReordering)
export const selectReorderableItems = createSelector((state) => state.listReordering.reorderableItems)
